// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__8lKjW","content":"GlobalSearch_content__2rKt2"};